import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedAgency: '',
  selectedState: '',
  agencies: [],
  states: []
};

export enum Directions {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}

interface SortConfig {
  key: string;
  direction: Directions;
}

const agencyCappingSlice = createSlice({
  name: 'agencyCappingSlice',
  initialState,
  reducers: {
    setSelectedAgency(state, action) {
      state.selectedAgency = action.payload;
    },
    setSelectedState(state, action) {
      state.selectedState = action?.payload;
    },
    setAgencies(state, action) {
      state.agencies = action?.payload;
    },
    setStates(state, action) {
      state.states = action.payload;
    }
  }
});

export const { setSelectedState, setStates, setAgencies, setSelectedAgency } =
  agencyCappingSlice.actions;
export default agencyCappingSlice.reducer;
